import { OnbOptionType } from '../../../../types';
import { LayoutDataType } from '../../types';

export const OPTIONS: OnbOptionType<LayoutDataType['familiarity']>[] = [
  {
    id: 'frequent',
    title: 'I use AI in many applications',
  },
  {
    id: 'occasional',
    title: "I've interacted with AI occasionally",
  },
  {
    id: 'first_experience',
    title: 'This is one of my first experiences',
  },
  {
    id: 'unfamiliar',
    title: 'Unfamiliar',
  },
];
